import { ClientRateCardTerm } from '@bringg/react-components';
import { Currencies, Currency, RateCardRateBase } from '@bringg/types';
import i18n from 'i18next';

const defaultPrecision = 2;

const getRateBase = (base: RateCardRateBase) => {
	const rateBaseTranslations = new Map<RateCardRateBase, string>([
		[RateCardRateBase.Flat, i18n.t('RATES.RATE_BASE.FLAT')],
		[RateCardRateBase.Miles, i18n.t('RATES.RATE_BASE.MILES')],
		[RateCardRateBase.ProgressiveMiles, i18n.t('RATES.RATE_BASE.PROGRESSIVE_MILES')],
		[RateCardRateBase.Units, i18n.t('RATES.RATE_BASE.UNITS')],
		[RateCardRateBase.Weight, i18n.t('RATES.RATE_BASE.WEIGHT')]
	]);

	return rateBaseTranslations.get(base);
};

const getOperator = (base: RateCardRateBase) => (base === RateCardRateBase.Flat ? '=' : 'x');

const getCurrencySign = (currency: Currency) => {
	return Currencies[String(currency).toUpperCase()]?.symbol ?? Currencies[Currency.USD].symbol;
};

const getAmountWithPrecision = (value: number): string => {
	const [, decimal] = String(value).split('.');
	return decimal?.length > defaultPrecision ? String(value) : value.toFixed(defaultPrecision);
};

export const getRateSummary = (term: ClientRateCardTerm): string => {
	const rateBase = getRateBase(term.rate_base);
	const operator = getOperator(term.rate_base);
	const currencySign = getCurrencySign(term.rate_currency);
	const amount = getAmountWithPrecision(term.rate_amount);

	if (term.rate_base === RateCardRateBase.ProgressiveMiles) {
		const progressiveRate = getAmountWithPrecision(term.rate_over_threshold_multiplier || 0);
		const threshold = getAmountWithPrecision(term.rate_threshold || 0);

		if (term.rate_threshold === 0 && term.rate_over_threshold_multiplier) {
			return i18n.t('RATES.SUMMARY.PROGRESSIVE_MILES_WITHOUT_THRESHOLD', {
				currencySign,
				amount,
				progressiveRate
			});
		}

		return i18n.t('RATES.SUMMARY.PROGRESSIVE_MILES_WITH_THRESHOLD', {
			currencySign,
			amount,
			threshold,
			progressiveRate
		});
	}

	return `${rateBase} ${operator} ${currencySign}${amount}`;
};
